import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const StrictApp: React.FC = () => (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element with id \"root\" not found');
}

const root = createRoot(rootElement);
root.render(<StrictApp />);

